import React from 'react'
import { GATSBY_DOMAIN } from '../../../utils'
import { SEO } from '../../../components'
import { graphql } from 'gatsby'
import '../form.css'

function SelfSuccessForcePage() {
  return (
    <main id="self-success-page">
      <div className="w-100 mb-n2">
        <iframe className="success-hype" src={`${GATSBY_DOMAIN}/hype_animation/success_hype.html`} title="Laser hair removal process"></iframe>
      </div>
      {/* Schedule Appointment Conversion Tag for AdRoll */}
      <img className="d-none" src="https://d.adroll.com/ipixel/QYHBL7Z5VJFXHLUOZD26HC/FRUGS2TU4RDWJDTILWKFWH?name=88dd2fee&conv_value={{REVENUE}}&adroll_currency=USD&ar_ed_order_id={{ORDERID}}" width="1" height="1" />
    </main>
  )
}

export const Head = ({ data, location }) => {
  const query = data.siteDataJson
  return (
    <SEO
      location={location} origin={query.origin}
      title={`Self Schedule Form Success | Milan Laser | Location: ${query.name}, ${query.stateAbbrev}`}
      description="Form Success | Milan Laser">
      <script>pintrk('track', 'lead');</script>
    </SEO>
  )
}

export const query = graphql`
{
  siteDataJson {
    name
    stateAbbrev
    origin
  }
}
`

export default SelfSuccessForcePage